export const returnTypesQuery = {
  id: 'id',
  name: 'reason',
  createdAt: 'created_at',
};
